import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "local-audio-control-wrapper" }
const _hoisted_2 = { class: "popover-hint" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_VolumeIndicator = _resolveComponent("VolumeIndicator")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_NcPopover = _resolveComponent("NcPopover")
  const _component_IconChevronUp = _resolveComponent("IconChevronUp")
  const _component_NcActionCaption = _resolveComponent("NcActionCaption")
  const _component_NcActionButton = _resolveComponent("NcActionButton")
  const _component_NcActionSeparator = _resolveComponent("NcActionSeparator")
  const _component_NcActions = _resolveComponent("NcActions")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NcPopover, {
      ref: "popover",
      boundary: $setup.boundaryElement,
      "show-triggers": [],
      "hide-triggers": ['click'],
      "auto-hide": false,
      "no-focus-trap": "",
      shown: $setup.popupShown
    }, {
      trigger: _withCtx(() => [
        _createVNode(_component_NcButton, {
          title: $options.audioButtonTitle,
          variant: $props.variant,
          "aria-label": $options.audioButtonAriaLabel,
          class: _normalizeClass({
						'no-audio-available': !$options.isAudioAvailable,
						'audio-control-button': $props.showDevices,
					}),
          disabled: !$options.isAudioAllowed,
          onClick: _withModifiers($options.toggleAudio, ["stop"])
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_VolumeIndicator, {
              "audio-preview-available": $options.isAudioAvailable,
              "audio-enabled": $options.showMicrophoneOn,
              "current-volume": $props.model.attributes.currentVolume,
              "volume-threshold": $props.model.attributes.volumeThreshold,
              "overlay-muted-color": "#888888"
            }, null, 8, ["audio-preview-available", "audio-enabled", "current-volume", "volume-threshold"])
          ]),
          _: 1
        }, 8, ["title", "variant", "aria-label", "class", "disabled", "onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString($setup.speakingWhileMutedWarner?.message), 1)
        ])
      ]),
      _: 1
    }, 8, ["boundary", "shown"]),
    ($props.showDevices)
      ? (_openBlock(), _createBlock(_component_NcActions, {
          key: 0,
          disabled: !$options.isAudioAvailable || !$options.isAudioAllowed,
          class: "audio-selector-button",
          onOpen: $setup.updateDevices
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_IconChevronUp, { size: 16 })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_NcActionCaption, {
              name: $options.t('spreed', 'Select a microphone')
            }, null, 8, ["name"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.audioInputDevices, (device) => {
              return (_openBlock(), _createBlock(_component_NcActionButton, {
                key: device.deviceId ?? 'none',
                class: "audio-selector__action",
                type: "radio",
                "model-value": $setup.audioInputId,
                value: device.deviceId,
                title: device.label,
                onClick: $event => ($options.handleAudioInputIdChange(device.deviceId))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(device.label), 1)
                ]),
                _: 2
              }, 1032, ["model-value", "value", "title", "onClick"]))
            }), 128)),
            ($setup.audioOutputSupported)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_NcActionSeparator),
                  _createVNode(_component_NcActionCaption, {
                    name: $options.t('spreed', 'Select a speaker')
                  }, null, 8, ["name"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.audioOutputDevices, (device) => {
                    return (_openBlock(), _createBlock(_component_NcActionButton, {
                      key: device.deviceId ?? 'none',
                      class: "audio-selector__action",
                      type: "radio",
                      "model-value": $setup.audioOutputId,
                      value: device.deviceId,
                      title: device.label,
                      onClick: $event => ($options.handleAudioOutputIdChange(device.deviceId))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(device.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["model-value", "value", "title", "onClick"]))
                  }), 128))
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["disabled", "onOpen"]))
      : _createCommentVNode("", true)
  ]))
}